import Splide from '@splidejs/splide'
import '../components/jquery.magnific-popup-update.js'
import { __sendVisit } from '../components/send-visit.js'
import { btnLoadingDone, btnLoadingStart } from '../components/loading.js'
import Swal from 'sweetalert2'
import { swalOption } from '../components/swal-opt.js'

import {
	addLoadingForNormalLink,
	barbaMarkup,
	hideLoadingEffect,
	saveScheduleEidToCookie,
	saveSeatingChartSize,
	setStyles,
	showSeatingChartHeader,
	upatePopupScheduleList,
} from '../utils/func.js'

import seatingChartEmptyCart from '../utils/seating-chart-empty-cart.js'

import postToCartFunc from '../utils/post-to-cart-func'
import { getCookie, setCookie, setCookieToPage } from '../utils/cookie.js'
import { seatWidgetIframe } from '../utils/seat-widget-ajax.js'
import {
	cleanLoading,
	openIframeOnSuccess,
} from '../components/update-seats-iframe.js'
import { bvTracking } from '../utils/tracking.js'
import callAjax from '../utils/call-ajax.js'
import submitTarget from '../utils/submit-target'
import { _query } from '../utils/query.js'
// import { triggerMatomo } from '../components/trigger-matomo'
import updateFees from '../utils/updateFees'
import { saveGeolocation } from '../components/getGeolocation.js'

// let submitData
window.orphanSeat = false
window.noResultSeat = false

export const BestAvailable = {
	namespace: 'best-available',
	beforeEnter() { },
	afterEnter() {
		barbaMarkup('bestAvailable')
		showSeatingChartHeader()
		addLoadingForNormalLink()
		refreshHeader()
		$('#backToReviewBtn').hide()
		// ajaxLoadMenu()
		const bestAvailablePage = new BestAvailablePage()

		//bundle page shares the same best available section
		if ($('input[name=bundle]').length > 0)
			setCookieToPage('fromBundle')
		else
			setCookieToPage('fromBestAvailable')

		const scheduleItem = $('.each-schedule-popup-ul').find('.schedule-item')
		upatePopupScheduleList(scheduleItem, 'best-available')

		setCookie('currentPage', 'BestAvailableSeat', 1, '')
		if (window.enableExitIntend) {
			window.exitIntent()
		}

		saveScheduleEidToCookie(window.myvars.scheduleEid)
		saveSeatingChartSize(true)
		__sendVisit()

		saveGeolocation()

		// triggerMatomo(window.myvars.scheduleEid, 'bestAvailable')
	},
}

export function getSectionsByPrice(schedule: string, mask: string, divId: string, status: string) {
	$('#sectionName').val('')
	$.get(
		'/ticket/best-available/get-sections-by-mask/schedule/' +
		schedule +
		'/mask/' +
		mask +
		'/status/' +
		status,
		(data) => {
			$('#' + divId).html(data)
		}
	)
}

export function getMasksBySchedule(schedule: string, status: string) {
	$('#mask').val('')
	window.bvScheduleId = schedule
	const url = `/ticket/best-available/get-masks-by-schedule/schedule/${schedule}/status/${status}`
	callAjax(url, {}, successGet)
}

export function successGet(data: string | JQuery.Node | ((this: HTMLElement, index: number, oldhtml: JQuery.htmlString) => string | JQuery.Node)) {
	$('#mask').html(data)
}

function postSeatOption(): Promise<string> {
	return new Promise((resolve, reject) => {
		$.ajax({
			url: '/ticket/best-available/result-ajax',
			type: 'POST',
			data: $('#best-available-form').serialize(),
			dataType: 'html',
			timeout: 60000, // Set your timeout value in milliseconds or 0 for unlimited
			success(data, textStatus, xhr) {
				const seatsFoundHtml = data
				// submitData = decodeURI($(data).serialize())
				if (seatsFoundHtml.includes('failedLabel')) {
					window.noResultSeat = true
				} else {
					window.noResultSeat = false
				}

				resolve(seatsFoundHtml)
			},
			error(jqXHR, textStatus, errorThrown) {
				if (textStatus === 'timeout') {
					// alert(myvars.timeoutErrorWhileTicketing) // Handle the timeout
					Swal.fire(swalOption(window.myvars.timeoutErrorWhileTicketing, false)).then(
						(result: any) => {
							if (result.value) {
								window.showLoading()
								window.location.reload()
							}
						}
					)
				} else {
					// alert(myvars.serverError) // Handle other error type
					Swal.fire(swalOption(window.myvars.serverError, false)).then((result: any) => {
						if (result.value) {
							window.showLoading()
							window.location.reload()
						}
					})
					// window.location.reload(true)
				}

				reject(errorThrown)
			},
		})
	})
}

function refreshHeader() {
	const header = _query('#mobile-header-wrapper')
	if (header.classList.contains('BvShowResult')) {
		header.classList.remove('BvShowResult')
	}
}

function bvTargetNext() {
	const UserDetecter = $('[best-available-php-convert-to-js]')
	const modelhelper = UserDetecter.data('modelhelper') === 1
	const notCookieCustomer = UserDetecter.data('notCookieCustomer') === 1
	submitTarget(
		modelhelper,
		notCookieCustomer
	)
}

export async function bvPostToCart() {
	try {
		await btnLoadingStart('#best-available-add-to-cart-btn')
		const tickets = await $('#best-available-result-form').serialize()
		await postToCartFunc(tickets, bvTargetNext)
	} catch (_error) {
		console.info(`catch error in function postToCart: ${_error}`)

		await btnLoadingDone('#best-available-add-to-cart-btn')

		if (window.orphanSeat) {
			$('#msg-holder-wrapper-seating-chart')
				// @ts-ignore
				.modal('show')
				.on('hidden.bs.modal', (e: any) => {
					bvTargetNext()
				})
		} else {
			if (window.existingSchedulesInCart) {
				postToCartFunc(_error, bvTargetNext)
			} else {
				$('#error-msg-holder-wrapper-seating-chart')
					// @ts-ignore
					.modal('show')
					.on('hidden.bs.modal', (e: any) => {
						// do something...
						// window.location.reload(true)
						seatingChartEmptyCart()
					})
			}
		}
	}
}

async function siteAjaxFormPrepare(addResultSlide: boolean) {
	await $('#select-tickets-active-content').show()
	await $('#schedDisplay').html(
		$('select[name=schedule] option:selected').text()
	)
	toggleSeatsFoundUI(addResultSlide)
}

export async function siteAjaxFormSubmit() {
	try {
		await window.addLoadingEffect()
		await bvTracking()
		const seatsFoundHtml = await postSeatOption()
		if (seatsFoundHtml) $('#seats-found-table').html(seatsFoundHtml)
		await siteAjaxFormPrepare(window.noResultSeat)
		hideLoadingEffect()
	} catch (e) {
		console.info(`error on siteAjaxFormSubmit: ${e}`)
	}
}

function toggleSeatsFoundUI(isReturn: boolean) {
	_query('#mobile-header-wrapper').classList.toggle('BvShowResult')
	$('#backToReviewBtn').toggle()
	$('.best-available-event-title').toggle()
	$('#best-available-form').toggle()
	$('#seats-found-container').toggle()

	// updateSeatsFoundImage()
	updateSlideshow(isReturn)
}

function _updateSlideshow() {
	const placeholder = _query('#result-chart-placehoder .swiper-slide-outer')
	if (window.bvSlider) {
		window.bvSlider.add(
			`<div class='splide__slide'>${placeholder.innerHTML}</div>`,
			0
		)
		window.bvSlider.go(0)
	}
}

function _rollbackSlideshow() {
	if (window.bvSlider && window.bvSlider.length > 2) window.bvSlider.remove(0)
}

async function updateSlideshow(isReturn: any) {
	// await showLoading()
	if (!isReturn) {
		await setStyles()
		await updateSeatsFoundImage()
		_updateSlideshow()
	} else {
		_rollbackSlideshow()
	}
}

function updateSeatsFoundImage() {
	const $selSeats = $('#select-tickets-active-scroll-wrapper input').map(
		function () {
			return $(this).attr('value')
		}
	)

	const selSeatsArr = $.makeArray($selSeats)
	const width = window.chartVars.chartWidth
	const height = window.chartVars.chartHeight
	const chartRatio = height / width
	const scheduledEid = $('#BestAvailable--Schedule').val()

	const frameSrc = seatWidgetIframe(
		scheduledEid,
		selSeatsArr.join(','),
		800,
		chartRatio,
		false
	)

	const img = '.seats-found-img'
	openIframeOnSuccess(frameSrc, img, chartRatio)
}

export class BestAvailablePage {
	constructor() {
		BestAvailablePage.showHideContent()
		// BestAvailablePage.plusMinusTicket()

		BestAvailablePage.seatingChartSlider()
		BestAvailablePage.seatingChartImagePopup()
		BestAvailablePage.getSectionsByPriceWay()
	}

	// static plusMinusTicket() {
	// 	const ticketNum = $('#ticket-num-value')

	// 	$('#add-one-btn').on('click', () => {
	// 		ticketNum.val(Number(ticketNum.val()) + 1)
	// 	})
	// 	$('#minus-one-btn').on('click', () => {
	// 		// event.preventDefault();
	// 		if (Number(ticketNum.val()) >= 2) {
	// 			ticketNum.val(Number(ticketNum.val()) - 1)
	// 		}
	// 	})
	// }

	static getSectionsByPriceWay() {
		const getSectionsByPrice = (schedule: string | number | string[] | undefined, mask: string | number | string[] | undefined, divId: string, status: string | number | string[] | undefined) => {
			$('#sectionName').val('')
			$.get( 
				'/ticket/best-available/get-sections-by-mask/schedule/' +
				schedule +
				'/mask/' +
				mask +
				'/status/' +
				status,
				(data) => {
					$('#' + divId).html(data)
				}
			)
		}

		if (window.myvars.frontEndBestAvailableOpen) {
			getSectionsByPrice(
				$('select[name=schedule]').val(),
				$('#mask').val(),
				'sectionName', $('#ticketStatus').val()
			)
		}
	}

	static seatingChartSlider() {
		const haveSlide = _query('#bvFigure--Inner')
		if (haveSlide) {
			window.bvSlider = new Splide('#bvFigure--Inner', {
				rewind: true,
				type: 'fade',
				isNavigation: true,
				pagination: true,
				arrows: true,
				cover: true,
			})
			window.bvSlider.mount()
		}
	}

	static seatingChartImagePopup() {
		($('.best-available-img') as any).magnificPopup({
			type: 'image',
			mainClass: 'mfp-fade',
		})
	}

	static showHideContent() {
		const commingFromSeatingChart =
			getCookie('choiceSeat') === 'fromSeatingChart'
		const commingFromSC = getCookie('choiceSeat') === 'fromSC'
		if (commingFromSC) {
			$(
				'#BackToSeatingChart, #BackToSeatingChart--Mobile, #BackToSeatingChartBottom--Mobile'
			).hide()
			$('#BackToSC, #BackToSC--Mobile, #BackToSCBottom--Mobile').show()
		} else {
			$(
				'#BackToSeatingChart, #BackToSeatingChart--Mobile, #BackToSeatingChartBottom--Mobile'
			).show()
			$('#BackToSC, #BackToSC--Mobile, #BackToSCBottom--Mobile').hide()
		}
	}
}

window.siteAjaxFormSubmit = siteAjaxFormSubmit
window.getSectionsByPrice = getSectionsByPrice
window.cleanLoading = cleanLoading
window.getMasksBySchedule = getMasksBySchedule
window.toggleSeatsFoundUI = toggleSeatsFoundUI
window.bvPostToCart = bvPostToCart
window.updateFees = updateFees
